import { Injectable } from "@angular/core";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

const DEFAULT_USER_SETTINGS_POPOUT_SIZE: any = { width: 885, height: 560 };

export class BfxUserSettingsComponentState {
  constructor(
    public componentBounds: any = DEFAULT_USER_SETTINGS_POPOUT_SIZE,
    public activeCategory:
      | BfxUserSettingsCategoryIndex
      | number = BfxUserSettingsCategoryIndex.General,
    public activeSubCategory:
      | BfxUserSettingsGeneralSubCategoryIndex
      | BfxUserSettingsOrderSubCategoryIndex
      | BfxUserSettingsNotificationsSubCategoryIndex
      | number = BfxUserSettingsGeneralSubCategoryIndex.General,
  ) {}
}

export enum BfxUserSettingsCategoryIndex {
  General,
  Order,
  // Trade,
  // Intervention,
  BmarkSummary,
  OrderEntry,
  //  Reporting,
  Notification,
  //  Acceptance,
  Panic,
}

export enum BfxUserSettingsSubCategoryIndex {
  Default,
}

/* As required when opening */
export enum BfxUserSettingsGeneralSubCategoryIndex {
  General,
}

/* As required when opening */
export enum BfxUserSettingsOrderSubCategoryIndex {
  Preferences,
  Temperature,
}

/* As required when opening */
export enum BfxUserSettingsNotificationsSubCategoryIndex {
  PopUp,
  Application,
  EmailSms,
}

@Injectable()
export class BfxUserSettingsService {
  private componentState: BfxUserSettingsComponentState = new BfxUserSettingsComponentState();

  constructor() {}

  public getComponentState(): any {
    return this.componentState;
  }
}
